import React, { useEffect } from 'react';
import TagManager from 'react-gtm-module';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';
import { clearCartData } from 'store/cartSlice';
import { selectVoucherDataFromCart } from 'store/cartSlice/selectors';
import { selectCartData } from 'store/cartSlice/selectors';
import useEmbedResize from 'utils/custom-hooks/useEmbedResize';
import { parseCartItemsForGTM } from 'utils/gtmUtils';
import { roundUpDecimals } from 'utils/tickets';

const RedirectToPaymentPage = () => {
  const { state } = useLocation();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const {
    selectedEvent,
    billingAndCustomerInfo: { email },
    selectedItems,
  } = useSelector(selectCartData);
  const {
    voucherCode: { code: appliedVoucherCode },
    voucherApplicableTickets,
  } = useSelector(selectVoucherDataFromCart);

  useEffect(() => {
    if (selectedEvent.gtm_code) {
      const tagManagerArgs = {
        gtmId: selectedEvent.gtm_code,
        dataLayer: {
          event: 'begin_checkout',
          ecommerce: {
            userEmail: email,
            currency: selectedEvent.currency,
            value: roundUpDecimals(state.cartTotal),
            items: parseCartItemsForGTM(
              selectedItems,
              selectedEvent.currency,
              appliedVoucherCode,
              voucherApplicableTickets,
            ),
          },
        },
      };

      TagManager.dataLayer({
        dataLayer: { event: 'remove_from_cart', ecommerce: null },
      });
      TagManager.initialize(tagManagerArgs);
    }
    dispatch(clearCartData());
  }, []);

  // useEmbedResize([]);

  if (!state && !state?.paymentLink) return <Navigate to="/404" />;

  window.location.href = state.paymentLink;

  return (
    <div className="page-container">
      <div className="section-container">
        <h1 className="title-lg text-center">
          {t('redirectToPaymentPage.title')}
        </h1>
      </div>
    </div>
  );
};

export default RedirectToPaymentPage;
